import { saveOrderId, saveOrderIndexOfDay } from '../../slices/orderSlice';
import { derivePaymentPercent, isFixedAmountOption } from './partialPaymentFields';

export const addDecimals = (num) => {
	return (Math.round(num * 100) / 100).toFixed(2);
};

export const updateOrder = (state) => {
	// Calculate items price
	state.itemsPrice = addDecimals(state.orderItems.reduce((acc, item) => acc + item.sellingPrice * item.qty, 0));

	state.totalPrice = Number(state.itemsPrice).toFixed(2);

	const price = Number(state.totalPrice) || 0;
	if (Array.isArray(state.scheduleNodes) && state.scheduleNodes.length > 0) {
		const fixedAmount = isFixedAmountOption(state.paymentDetail?.prePaymentOption);
		state.scheduleNodes.forEach((node) => {
			if (fixedAmount) {
				node.paymentPercent = derivePaymentPercent(node.paymentAmount, price);
			} else {
				node.paymentAmount = Number(((Number(node.paymentPercent || 0) / 100) * price).toFixed(2));
			}
		});
	}

	localStorage.setItem('order', JSON.stringify(state)); // JS Object to JSON String

	return state;
};

/**
 * 调用后端取号接口，写入完整 orderId（禁止前端拼日期）
 * @param {Function} dispatch
 * @param {{ _id: string, alias?: string }} sale
 * @param {Function} getOrderIndexBySelectedSale RTK mutation trigger
 */
export const generateOrderIdForSale = async (dispatch, sale, getOrderIndexBySelectedSale) => {
	const saleId = sale?._id;
	if (!saleId || typeof getOrderIndexBySelectedSale !== 'function') {
		return null;
	}

	const res = await getOrderIndexBySelectedSale({ _id: saleId }).unwrap();
	if (!res?.orderId) {
		throw new Error('后端未返回订单编号');
	}
	dispatch(saveOrderId(res.orderId));
	dispatch(saveOrderIndexOfDay(res.incrementIndex));
	return res;
};

export const ORDER_ROLES = {
	ASSISTANT: 'assistant',
	SALE: 'sale',
	MANAGER: 'manager',
	USER: 'user',
	ADMIN: 'admin',
};

/** 代建角色：须先选销售员；单号/当日序号/客户均按该销售 */
export const isSaleProxyOrderRole = (role) => role === ORDER_ROLES.ASSISTANT || role === ORDER_ROLES.ADMIN;

/** 与 SelectOrderAssistantModal 选人写入字段一致 */
export const normalizeUserToAssistant = (user) => ({
	_id: user?._id,
	name: user?.name ?? '',
	email: user?.email ?? '',
	phone: user?.phone ?? '',
});

export const ORDER_ACTIONS = {
	SAVE_DRAFT: 'saveAsDraft_button',
	PLACE_ORDER: 'placeOrder_button',
	UPDATE_DRAFT: 'updateDraft_button',
};
